import { domQuerySelector } from 'pf-frontend-common/src/helper/dom/query-selector';

import { configGetSettings } from 'common/helper/config/get-settings';
import { ContentGroupStrategyTabFactory } from 'common/module/content-group/strategy/tab.factory';
import { PropertyCtaService } from 'common/module/property-cta/service';
import { PropertyCtaStatsService } from 'common/module/property-cta/stats/service';
import { AbTestService } from 'common/service/ab-test/service';
import { AgentStoreService } from 'common/service/agent-store/service';
import { BrokerStoreService } from 'common/service/broker-store/service';
import { FooterService } from 'common/service/footer/service';
import { HeaderService } from 'common/service/header/service';
import { LanguageSelectorService } from 'common/service/language-selector/service';
import { PrivacyPromptService } from 'common/service/privacy-prompt/service';
import { PropertyStoreService } from 'common/service/property-store/service';
import { UserAuthenticationService } from 'common/service/user-authentication/service';
import { BrokerPageBundleSettingsInterface } from 'desktop/entry/broker-page/bundle/settings.interface';
import { AgentTabViewFactory } from 'desktop/module/agent/tab/view.factory';
import { AgentTabViewOptionsInterface } from 'desktop/module/agent/tab/view-options.interface';
import { BrokerPageViewFactory } from 'desktop/module/broker/page/view.factory';
import { ClientPageTabDecorator } from 'desktop/module/client/page/tab/decorator';
import { PropertyTabViewFactory } from 'desktop/module/property/tab/view.factory';
import { PropertyTabViewOptionsInterface } from 'desktop/module/property/tab/view-options.interface';
import { PropertyLeadEmailService } from 'desktop/module/property-lead-email/service';
import { PropertyLeadPhoneService } from 'desktop/module/property-lead-phone/service';
import { UserAvatarComponent } from 'desktop/module/user/avatar/component';

AbTestService().initialize();

const bundleSettings = configGetSettings<BrokerPageBundleSettingsInterface>();

// Common services
HeaderService()
  .setComponents({
    UserAvatarComponent,
  })
  .render();
UserAuthenticationService();
FooterService();

LanguageSelectorService();

PropertyLeadEmailService();
PropertyLeadPhoneService();
PropertyCtaService();
PropertyCtaStatsService();

PrivacyPromptService();

// Initialize stores
const brokerStoreService = BrokerStoreService();

brokerStoreService.initialize({
  payload: bundleSettings.broker.payload,
});

// Initialize models
const brokerModel = brokerStoreService.getOneById(bundleSettings.broker.payload.data.id);

// Initialize view
const clientPage = BrokerPageViewFactory();
const element = domQuerySelector(document, '[data-qs="broker-page"]');

clientPage.initialize({
  element,
  brokerModel,
  subview: {
    tab: {
      viewOptions: {
        element: domQuerySelector(element, '[data-qs="tab"]'),
        strategy: ContentGroupStrategyTabFactory(),
      },
    },
  },
});

// Render view
clientPage.render();

// If agent tab is enabled then initialize and render it
if (bundleSettings.agent) {
  const agentStoreService = AgentStoreService();

  agentStoreService.initialize({
    payload: bundleSettings.agent.payload,
  });

  const agentTabDecorator = new ClientPageTabDecorator<AgentTabViewOptionsInterface>(
    'tab-agents',
    AgentTabViewFactory(),
    clientPage
  );

  agentTabDecorator.initialize({
    element: domQuerySelector(element, '[data-qs-content="tab-agents"]'),
    model: brokerModel,
    payload: bundleSettings.agent.payload,
    form: bundleSettings.agent.form,
    prefix: bundleSettings.agent.prefix,
  });

  agentTabDecorator.render();
}

// If property tab is enabled then initialize and render it
if (bundleSettings.property) {
  const propertyStoreService = PropertyStoreService();

  propertyStoreService.initialize({
    payload: bundleSettings.property.payload,
  });

  const propertyTabDecorator = new ClientPageTabDecorator<PropertyTabViewOptionsInterface>(
    'tab-properties',
    PropertyTabViewFactory(),
    clientPage
  );

  propertyTabDecorator.initialize({
    element: domQuerySelector(element, '[data-qs-content="tab-properties"]'),
    model: brokerModel,
    payload: bundleSettings.property.payload,
    form: bundleSettings.property.form,
    prefix: bundleSettings.property.prefix,
  });

  propertyTabDecorator.render();
}
